import styled from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        align-items: center;
        gap: 8px;

        & > h2 {
            ${({ theme }) => theme.font.large_bold};
        }

        & > input {
            flex-grow: 1;
            padding: 8px 16px;
            ${({ theme }) => theme.font.extra_small};
            border: 1px solid ${({ theme }) => theme.color.grey3};
            border-radius: 4px;
        }
    `,
}